import { AxiosResponse } from 'axios'
import { http } from '../../utils'
import { Response, MonthlyBill, MonthlyBillsResponse, GSTR1Report } from '../types'

export interface CreateMonthlyBillAPIResponse extends Response {
  data: MonthlyBill
}

export interface DeleteMonthlyBillAPIResponse extends Response {
  data: MonthlyBill
}

export interface FetchMonthlyBillsAPIResponse extends Response {
  data: MonthlyBillsResponse[]
}

export interface Gstr1SummaryReportAPIResponse extends Response {
  data: GSTR1Report
}

export type CreateMonthlyBillRequest = {
  accountId: number
  fromDate: string
  toDate: string
  createDate: string
  invoiceNo: number
  discount?: number
  challanId?: number
  billFormat?: string
  invoiceId?: number
}

export const createMonthlyBill = (request: CreateMonthlyBillRequest) => {
  return http
    .post('/interim_bill/pvt', request)
    .then((response: AxiosResponse) => response)
}

export function fetchMonthlyBill(accountId: number, from: string, to: string, isGst: boolean) {
  let url = `/interim_bill/pvt?account_id=${accountId}&isGst=${isGst}`
  if(isGst != null) {
    url = `${url}&gst_type=${isGst ? "ALL_GST" : "NONE"}`
  }
  if(from) {
    url = `${url}&from=${from}`
  }
  if(to) {
    url = `${url}&to=${to}`
  }
  return http
    .get(url)
    .then((response: AxiosResponse) => response)
}

export function fetchAllBills(
  finYear: string,
  isGst: boolean | null,
  from?: string,
  to?: string,
  siteId?: string,
  partyInvoices?: string,
  partyId?: string,
  sortBy?: string
) {
  let accountId = siteId ? siteId : '0'
  let url = `/interim_bill/pvt?account_id=${accountId}`
  if (isGst === true || isGst === false) {
    url = `${url}&isGst=${isGst}`
    url = `${url}&gst_type=${isGst ? 'ALL_GST' : 'NONE'}`
  }
  if(finYear != null) {
    url = `${url}&fin_year=${finYear}`
  }
  if(from) {
    url = `${url}&from=${from}`
  }
  if(to) {
    url = `${url}&to=${to}`
  }

   if(partyInvoices) {
    url = `${url}&party_invoices=${partyInvoices}`
  }
  if(partyId) {
    url = `${url}&party_id=${partyId}`
  }
  if (sortBy) {
    url = `${url}&sort_by=${sortBy}`
  }
  return http
    .get(url)
    .then((response: AxiosResponse) => response)
}

export function fetchGSTR1Json(from: string, to: string) {
  let url = `/interim_bill/pvt/gstr1_json?isGst=true`
  
  if(from) {
    url = `${url}&from=${from}`
  }
  if(to) {
    url = `${url}&to=${to}`
  }
  return http
    .get(url)
    .then((response: AxiosResponse) => response)
}

export function deleteMonthlyBill(id: number) {
  return http
    .delete(`/interim_bill/pvt?id=${id}`)
    .then((response: AxiosResponse) => response)
}

export function adjustBillingGap(accountId: number) {
  return http
    .put(`/interim_bill/pvt/adjust_billing_gap?account_id=${accountId}`)
    .then((response: AxiosResponse) => response)
}

export interface InterimBillInvoiceDetails {
  invoiceDisplayNumber: string
  buyerName: string
  siteAddress: string
  invoiceTotal: number
  cgstRate: number
  sgstRate: number
  igstRate: number
  crnDBNValue?: number
}

export interface InterimBillInvoiceResponse extends Response {
  data: InterimBillInvoiceDetails
}

export interface InvoicePdfResponse extends Response {
  data: string
}

export interface DebitCreditNoteLineEntry {
  itemName: string
  amount: number
  quantity?: number
  duration?: number
  rate?: number
}

export interface CreateDebitCreditNoteRequest {
  invoiceId: number
  noteType: 'DBN' | 'CRN'
  createDate: string
  invoiceNo: string
  taxableAmount: number
  invoiceTotal: number
  cgstRate: number
  sgstRate: number
  igstRate: number
  cgstValue: number
  sgstValue: number
  igstValue: number
  lineEntries: DebitCreditNoteLineEntry[]
}

export interface CreateDebitCreditNoteResponse extends Response {
  data?: unknown
}

export function fetchInterimBillInvoice(
  id: number,
  noteType: 'DBN' | 'CRN'
) {
  return http
    .get<InterimBillInvoiceResponse>(
      `/interim_bill/pvt/invoice?id=${id}&note_type=${noteType}`
    )
    .then((response: AxiosResponse<InterimBillInvoiceResponse>) => response.data)
}

export function fetchInvoicePdf(id: number): Promise<InvoicePdfResponse> {
  return http
    .get<InvoicePdfResponse>(`/interim_bill/pvt/invoice_pdf?id=${id}`)
    .then((response: AxiosResponse<InvoicePdfResponse>) => response.data)
}

export function createDebitCreditNote(body: CreateDebitCreditNoteRequest) {
  return http
    .post<CreateDebitCreditNoteResponse>('/interim_bill/pvt/note', body)
    .then((response: AxiosResponse<CreateDebitCreditNoteResponse>) => response.data)
}
